<template>
	<div>
		<el-button @click.native.prevent="reloadDefault()" type="primary" size="small" round> Charger la configuration par défaut</el-button>
		<el-button @click.native.prevent="addFamily()" type="primary" size="small" round> Ajouter une famille de risque</el-button>
		<br>
		<div v-if="tableFamilles.length">
			<div class="centerCotation" v-for="(family, index) in tableFamilles" :key="family.id">
				<div class="family">
					<h4><div contenteditable="true" class="editme" @blur="onEdit" @keydown.enter="end" :editId="index" editField='nomFamille' :dataInit="family.nomFamille">{{ family.nomFamille }}</div></h4>
					<el-button class="btnDeleteFamily" @click.native.prevent="deleteFamily(family.id)" type="danger" icon="el-icon-delete" circle></el-button>
				</div>
				<b-table ref="tableFamily" small responsive striped :items="getRisquesByFamille(family)" :fields="fieldsFamily" show-empty>
					<template slot="empty" slot-scope="">
						<div style="text-align:center;">Cette famille de risque ne comporte aucun risque</div>
					</template>
					<template v-slot:cell(risque)="data">
						<div contenteditable="true" class="editme" style="text-align: initial;" @blur="onEditRisque" @keydown.enter="endEditRisque" :editFamille="family.id" :editId="data.item.id" editField='nomRisque' :dataInit="data.item.nomRisque">{{ data.item.nomRisque }}</div>
					</template>
					<template v-slot:cell(actions)="data">
						<i class="far fa-trash-alt" @click="deleteRow(data.item.id)" style="color:red; cursor:pointer;"></i>
					</template>
				</b-table>
				<el-button @click.native.prevent="addRow(family.id)" type="text" size="small"> Ajouter un risque</el-button>
			</div>
			<br>
		</div>
		<div v-else class="centerCotation">
			<h4>Aucune famille de risque</h4>
		</div>
	</div>
</template>

<script>
import scriptQse from '../../../script/script-qse.js';
export default {
	data () {
		return {
			fieldsFamily: [
				{ key: 'risque', label: 'Risque' },
				{ key: 'actions', label: '' }
			]
		}
	},
	methods: {
		updateExtrafieldsQse: scriptQse.updateExtrafieldsQse,
		getExtrafieldsDefault: scriptQse.getExtrafieldsDefault,
		reloadDefault(){
			if(confirm("Voulez-vous recharger les risques par défaut?")){
				this.getExtrafieldsDefault()
				this.$store.commit('initializeFamillesRisques', Object.assign({}, this.$store.state.famillesRisquesDefault))
				this.$store.commit('updateAutoIncrementRisque', this.$store.state.autoIncrementRisqueDefault)
				this.$store.commit('updateAutoIncrementFamille', this.$store.state.autoIncrementFamilleDefault)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},
		deleteRow(idRisque) {
			if(confirm("Voulez-vous supprimer ce risque ?")){
				this.$store.commit("deleteRisque", idRisque)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},
		addRow(idFamille) {
			this.$store.commit("addRisque", idFamille)
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},
		deleteFamily(idFamille) {
			if(confirm("Voulez-vous supprimer cette famille de risques ?")){
				this.$store.commit("deleteFamille", idFamille)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},
		addFamily() {
			this.$store.commit("addFamille")
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},
		onEdit (evt) {
			var initValue = evt.target.getAttribute('dataInit')
			var newValue = evt.target.innerText
			var editId = evt.target.getAttribute('editId')
			var editField = evt.target.getAttribute('editField')
			var editTable = evt.target.getAttribute('editTable')

			if (newValue !== initValue) {
				this.$store.commit("updateFamilles", {id: editId, field: editField, value: newValue})
				evt.target.setAttribute('dataInit', newValue)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},

		endEdit (evt) {
			evt.target.blur(evt)	
		},
		onEditRisque (evt) {
			var initValue = evt.target.getAttribute('dataInit')
			var newValue = evt.target.innerText
			var editId = evt.target.getAttribute('editId')
			var editField = evt.target.getAttribute('editField')
			var editTable = evt.target.getAttribute('editTable')
			var editFamille = evt.target.getAttribute('editFamille')

			if (newValue !== initValue) {
				this.$store.commit("updateRisques", {idFamille: editFamille, id: editId, field: editField, value: newValue})
				evt.target.setAttribute('dataInit', newValue)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},

		endEditRisque (evt) {
			evt.target.blur(evt)	
		},
		getRisquesByFamille(famille) {
			return this.$store.state.famillesRisques.risques.filter(a => (a.idFamille == famille.id))
		}
	},
	computed: {
		tableFamilles () {
			return this.$store.state.famillesRisques.familles
		}
	},
	mounted () {
	}
}
</script>

<style>
 	button:focus{
		outline:none;
	}

	.family{
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btnDeleteFamily{
		margin: 1em;
	}
</style>